
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/getting-started/unit-4",
      function () {
        return require("private-next-pages/getting-started/unit-4/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/getting-started/unit-4"])
      });
    }
  